import React, { useState } from 'react';
import axios from 'axios';
import { X, Send } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const inputCls = 'w-full bg-zinc-800 border border-zinc-700 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-[#C41E3A]';

const defaultMessage = (invoice) => `Dear ${invoice.client?.contact_person || invoice.client?.company_name || 'Customer'},

Thank you for choosing BrandStage! Please find attached invoice ${invoice.invoice_number} for ${invoice.purpose}.

I'd love to hear what you're planning to showcase - feel free to reply to this email or call me anytime.

Warm regards,
Team BrandStage`;

export default function InvoiceEmailModal({ invoice, onClose, onSent }) {
  const [form, setForm] = useState({
    to_email: invoice.client?.email || '',
    subject: `Your BrandStage invoice ${invoice.invoice_number}`,
    message: defaultMessage(invoice),
  });
  const [sending, setSending] = useState(false);

  const send = async () => {
    setSending(true);
    try {
      await axios.post(`${API_URL}/api/admin/invoices/${invoice.id}/email`, form, { withCredentials: true });
      toast.success(`Invoice emailed to ${form.to_email}`);
      onSent();
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Please check the email address and message');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-50" data-testid="invoice-email-modal">
      <div className="bg-zinc-900 border border-zinc-700 rounded-2xl p-6 max-w-xl w-full">
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-lg font-bold text-white">Email invoice {invoice.invoice_number}</h2>
          <button type="button" onClick={onClose} className="text-zinc-400 hover:text-white" data-testid="invoice-email-close"><X className="w-5 h-5" /></button>
        </div>
        <div className="space-y-3">
          <input className={inputCls} type="email" value={form.to_email} onChange={(e) => setForm({ ...form, to_email: e.target.value })} placeholder="Client email" data-testid="invoice-email-to" />
          <input className={inputCls} value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="invoice-email-subject" />
          <textarea className={`${inputCls} h-48`} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="invoice-email-message" />
          <p className="text-xs text-zinc-500">The invoice PDF is attached automatically.</p>
        </div>
        <button
          type="button"
          onClick={send}
          disabled={sending || !form.to_email}
          data-testid="invoice-email-send-btn"
          className="w-full mt-5 bg-[#C41E3A] hover:bg-[#A01830] disabled:opacity-50 text-white py-3 rounded-lg font-semibold flex items-center justify-center gap-2"
        >
          <Send className="w-4 h-4" /> {sending ? 'Sending...' : 'Send to client'}
        </button>
      </div>
    </div>
  );
}
